import styled from 'styled-components';

import { spacing, colors, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { EventIcon } from '../../events/components/EventIcon';

const Wrapper = styled.div`
  display: flex;
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  border-radius: ${pxToRem(30)};
  margin-right: ${spacing.threeQuarter};
  text-align: center;
  color: ${colors.textPrimary};
  background-color: ${colors.grey5};
  justify-content: center;
  align-items: center;
  ${smallShadow}
`;

type EventIconBubbleProps = {
  eventType: string;
};

export const EventIconBubble = ({ eventType }: EventIconBubbleProps) => (
  <Wrapper>
    <EventIcon width={18} height={18} eventName={eventType} />
  </Wrapper>
);
